import { CloudProviderConfig } from "@/types/onboarding";
import { Card, CardContent, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

type ProviderStatus = "none" | "connected" | "expired";

interface ProviderCardProps {
  id: string;
  config: CloudProviderConfig;
  onConnect: (providerId: string) => void;
  status?: ProviderStatus;
}

const ProviderCard: React.FC<ProviderCardProps> = ({
  id,
  config,
  onConnect,
  status = "none",
}) => {
  const isExpired = status === "expired";
  const buttonLabel =
    status === "connected" ? "Manage" : isExpired ? "Renew" : "Connect";
  const cardBorder = isExpired ? "border-red-500" : "";

  return (
    <Card
      className={`w-64 hover:shadow-md cursor-pointer transition-shadow ${cardBorder}`}
    >
      <CardContent className="p-6 text-center">
        <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
          <img
            src={config.logo}
            alt={config.name}
            className="w-full h-full object-contain"
          />
        </div>
        <CardTitle className="text-lg mb-1 text-gray-900 text-center">
          {config.name}
        </CardTitle>
        {isExpired && (
          <p className="text-xs text-red-600 font-semibold uppercase mb-3">
            Expired
          </p>
        )}
        <Button
          onClick={() => onConnect(id)}
          className="w-full bg-[#3CC858] hover:bg-[#34B04A]"
        >
          {buttonLabel}
        </Button>
      </CardContent>
    </Card>
  );
};

export default ProviderCard;
